import React from "react";
import { Layout } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router";
import { useBrandToken } from "@repo/ui";
import type { SideBarItem } from "./SideBar";
import type { CustomFooterProps } from "./Footer";
import SideBar from "./SideBar";
import CustomHeader from "./Header";
import CustomFooter from "./Footer";

export type CustomLayoutProps = {
    logoSrc: string;
    brandName?: string;
    sidebarItems: SideBarItem[];
    /** Что-то по центру хедера (поиск, навигация и т.п.) */
    headerCenterContent?: React.ReactNode;
    /** Пропсы бренда для футера */
    footerBrand?: CustomFooterProps["brand"];
    /** Отступы контента */
    contentPadding?: number | string;
    /** Ширина сайдбара */
    siderWidth?: number;
    /** Breakpoint, ниже которого сайдбар автоскрывается */
    breakpoint?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
    /** Можно пробросить детей вместо <Outlet/> */
    children?: React.ReactNode;
};

export default function AppLayout({
    brandName = "OptimS",
    sidebarItems,
    footerBrand,
    children,
}: CustomLayoutProps) {
    const token = useBrandToken();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const [sidebarOpen, setSidebarOpen] = React.useState(true);

    // находим активный ключ по текущему пути
    const flat = React.useMemo(() => {
        const out: SideBarItem[] = [];
        const walk = (arr: SideBarItem[]) =>
            arr.forEach((it) => {
                out.push(it);
                if (it.children) walk(it.children);
            });
        walk(sidebarItems);
        return out;
    }, [sidebarItems]);

    const selectedKey = React.useMemo(() => {
        const direct = flat.find((i) => i.to === pathname)?.key;
        if (direct) {
            return direct;
        }
        return flat
            .filter((i) => i.to && i.to !== "/")
            .sort((a, b) => (b.to?.length ?? 0) - (a.to?.length ?? 0))
            .find((i) => i.to && pathname.startsWith(i.to!))?.key;
    }, [flat, pathname]);

    return (
        <Layout style={{ minHeight: "100vh", background: token.colorBgLayout }}>
            <CustomHeader isMenuOpen={sidebarOpen} onToggleMenu={() => setSidebarOpen((v) => !v)} />

            <Layout
                style={{
                    transition: "margin-left .2s ease",
                    minHeight: "100vh",
                }}
            >
                <SideBar
                    open={sidebarOpen}
                    selectedKey={selectedKey}
                    onOpenChange={setSidebarOpen}
                    onNavigate={(to) => navigate(to)}
                />

                <Layout.Content className="justify-items-center p-10 bg-white">
                    {children ?? <Outlet />}
                </Layout.Content>
            </Layout>
            <CustomFooter
                brand={
                    footerBrand ?? {
                        name: brandName,
                        email: "optimsss@gmail.com",
                        phone: "+7 (771) 450-89-97",
                        address: "Казахстан, Алматы",
                    }
                }
            />
        </Layout>
    );
}
